import React from 'react'
import ProductUserStore from '../store/ProductUser'

const ProductUserStoreContext = React.createContext(ProductUserStore)

const useProductUser = () => React.useContext(ProductUserStoreContext)
export default useProductUser;
